import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const SystemUsers = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Sistem Kullanıcıları
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Sistem kullanıcıları listesi burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default SystemUsers;
